import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import 'designs/tokens.css';
import './index.css';
import App from './App';
import {
  LegalPage,
  AquaristPage,
  HomePage,
  IdleCafePage,
} from 'pages';
import { LEGACY_LEGAL_ROUTES, ROUTES } from 'constants/index';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.home} element={<App />}>
          <Route index element={<HomePage />} />

          <Route path="aquarist" element={<AquaristPage />} />
          <Route path="idlecafe" element={<IdleCafePage />} />

          <Route path="privacypolicy" element={<LegalPage doc="privacy" />} />
          <Route
            path="termsandconditions"
            element={<LegalPage doc="terms" />}
          />
          <Route path="gdprcompliance" element={<LegalPage doc="gdpr" />} />

          {/* The app store listings still point at the old addresses. */}
          {LEGACY_LEGAL_ROUTES.map((route) => (
            <Route
              key={route.from}
              path={route.from}
              element={<Navigate to={route.to} replace />}
            />
          ))}

          <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
